/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SysqueOptionsLineComponent } from './sysque-options-line.component';

@NgModule({
  declarations: [SysqueOptionsLineComponent],
  imports: [CommonModule, FormsModule],
  exports: [SysqueOptionsLineComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueOptionsLineModule {}
